import { useSearchParams } from '@faceup/router'
import { type ReactNode, useEffect, useState } from 'react'
import { isFromAkutan } from '../utils/urls'

type PointerEventsMemberProps = {
  children: ReactNode
}

/**
 * @description This component allows disabling interactions, primarily for Akutan customization.
 * Uses the `inert` attribute to block all user interaction (mouse clicks, keyboard navigation,
 * focus) while keeping content visible and scrollable.
 */
const PointerEventsMember = ({ children }: PointerEventsMemberProps) => {
  const [interactionsEnabled, setInteractionsEnabled] = useState<boolean>(true)
  const [params] = useSearchParams()

  useEffect(() => {
    if (params.has('disablePointerEvents') && isFromAkutan(document.referrer)) {
      setInteractionsEnabled(false)
    }
  }, [params])

  return (
    <div className={interactionsEnabled ? '' : 'cursor-not-allowed'}>
      <div inert={!interactionsEnabled}>{children}</div>
    </div>
  )
}

export default PointerEventsMember
